import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import PanitiaLogin from './components/PanitiaLogin';
import Dashboard from './components/Dashboard';
import PanitiaDashboard from './components/PanitiaDashboard';
import QRCode from './components/QRCode';
import ProtectedRoute from './components/ProtectedRoute';
import PanitiaProtectedRoute from './components/PanitiaProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/panitia-login" element={<PanitiaLogin />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/panitia-dashboard" 
              element={
                <PanitiaProtectedRoute>
                  <PanitiaDashboard />
                </PanitiaProtectedRoute>
              } 
            />
            <Route 
              path="/qrcode" 
              element={
                <ProtectedRoute>
                  <QRCode />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 